import type { ReactNode } from "react";
import { t } from "ttag";

import { usePageTitle } from "metabase/hooks/use-page-title";
import { Flex } from "metabase/ui";

interface TransformTopNavLayoutProps {
  children: ReactNode;
}

export const JobSectionLayout = ({ children }: TransformTopNavLayoutProps) => {
  // A fractional index, not 0: a tie with the app-level title (also 0) would
  // resolve by React's effect mount order rather than the intended
  // hierarchy, putting the app name in the wrong spot. See use-page-title.ts.
  usePageTitle(t`Jobs`, { titleIndex: 0.5 });
  return (
    <Flex direction="column" w="100%" h="100%">
      {children}
    </Flex>
  );
};
